import { css } from "emotion";

export const fontString = `

`;

export default css(fontString);
